export default {
    queueManagement: {
        queuedata: [],
        filter: {
            Queue: '',
        }

    },

}